module.exports = __webpack_public_path__ + "img/52.e32158b7.jpg";